import VueDropzone from 'vue2-dropzone'
import excelParser from '../../../../services/excel-parser'
import purchaseHistoryService from '../../../../services/provider/purchase-history'
import _ from 'lodash'

const MAX_FILE_SIZE_BYTES = 50 * 1024 * 1024

export default {
    components: {
        VueDropzone
    },
    data() {
        return {
            item: {},
            listHeader: [],
            isFileSelect: false,
            modalError: '',
            labelName: {
                manufacturer: 'Manufacturer',
                item_number: 'Item Number',
                model_number: 'Model Number',
                sku: 'SKU',
                udi: 'UDI',
                product_description: 'Product Description',
                catalog_number: 'Catalog Number',
                serial_number: 'Serial Number',
                ndc: 'NDC',
                gtin: 'GTIN'
            },
            dropzoneOptions: {
                url: '#',
                acceptedFiles: '.xlsx,.xls',
                maxFiles: 1,
                maxFilesize: 50,
                previewsContainer: false,
                autoProcessQueue: false
            }
        }
    },
    methods: {
        resetState() {
            this.item = {
                manufacturer: null,
                item_number: null,
                model_number: null,
                sku: null,
                udi: null,
                product_description: null,
                catalog_number: null,
                serial_number: null,
                ndc: null,
                gtin: null,
                file: null
            }
            this.listHeader = []
            this.isFileSelect = false
            this.modalError = ''
        },
        forceRerenderInsert() {
            this.resetState()
            this.$refs.modal.show()
        },
        getHeaderList(headers = []) {
            return headers.map(x => ({ value: x, text: x }))
        },
        async addSuccess(file) {
            this.resetState()

            if (!file || !file.name || !_.isArray(file.name.split('.'))) {
                return
            }

            const ext = file.name.split('.').pop().toLowerCase()
            if (!['xls', 'xlsx'].includes(ext)) {
                this.modalError = 'Only Excel files (.xlsx, .xls) are allowed.'
                return
            }

            if (file.size > MAX_FILE_SIZE_BYTES) {
                this.modalError = 'File size must not exceed 50 MB.'
                return
            }

            this.item.file = file
            try {
                const formData = new FormData()
                formData.append('file', this.item.file)
                const res = await excelParser.getExcelHeaders(formData)
                if (res.error) {
                    this.modalError = res.data?.m || 'Unable to read the file headers. Please try again.'
                    return
                }

                const headers = res.data?.d || []
                this.listHeader = this.getHeaderList(headers)
                this.isFileSelect = true
            } catch (e) {
                this.modalError = 'Unable to read the file headers. Please try again.'
            }
        },
        async save() {
            this.modalError = ''
            const isValid = await this.$refs.observer.validate()
            if (!isValid || !this.item.file) {
                return
            }

            const formData = new FormData()
            formData.append('manufacturer', this.item.manufacturer)
            formData.append('productDescription', this.item.product_description)
            formData.append('itemNumber', this.item.item_number || '')
            formData.append('modelNumber', this.item.model_number || '')
            formData.append('sku', this.item.sku || '')
            formData.append('udi', this.item.udi || '')
            formData.append('catalogNumber', this.item.catalog_number || '')
            formData.append('serialNumber', this.item.serial_number || '')
            formData.append('ndc', this.item.ndc || '')
            formData.append('gtin', this.item.gtin || '')
            formData.append('file', this.item.file)

            try {
                const res = await purchaseHistoryService.uploadPOImportFile(formData)
                if (!res.error) {
                    this.$emit('onCompleted', 'UPDATE')
                    this.$refs.modal.hide()
                    return
                }
                this.modalError = res.data?.m || 'Failed to upload file. Please try again.'
            } catch (e) {
                this.modalError = e?.response?.data?.m || 'Failed to upload file. Please try again.'
            }
        },
    }
}
